import script from "./FaqSection.vue?vue&type=script&setup=true&lang=js"
export * from "./FaqSection.vue?vue&type=script&setup=true&lang=js"

import "./FaqSection.vue?vue&type=style&index=0&id=5991af37&scoped=true&lang=scss"

import exportComponent from "/Users/alesandraefimova/Work/x-global-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5991af37"]])

export default __exports__